export class FaturamentoCreditoFinanceiroSomatorioVO {

  somatorio: number;
  idComposicaoRda: number;
  tecnac: boolean;
  pdim: number;
  pdic: number;
  credito: number;
  limite: number;
  excedente: number;
}
